import * as z from "zod";

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const phoneRegex = /^(09\d{9})$/;

export const formSchema = z.object({
    identifier: z.string().refine(value => emailRegex.test(value) || phoneRegex.test(value), {
        message: "لطفاً یک ایمیل یا شماره تلفن معتبر وارد کنید.",
    }),
    password: z.string().min(8, { message: "رمز عبور باید حداقل ۸ کاراکتر باشد." }),
    otp_code: z.string().refine(val => val.length === 0 || val.length === 6, {
        message: "کد تأیید باید ۶ رقم باشد."
    }).optional(),
});

export type FormData = z.infer<typeof formSchema>;
export type FormStep = 'details' | 'verify';
